export * from './getCachedConfig';
import { getPortalId } from 'unified-navigation-ui/js/utils/getPortalId';
import { Metrics } from 'unified-navigation-ui/js/utils/metrics';
import { get, set } from 'unified-navigation-ui/js/utils/tempStorage';
import { apiClientWithMiddleware } from 'unified-navigation-ui/utils/API';
import { GET_CONFIG_FAILURE, GET_HUBLESS_CONFIG_FAILURE, INACCURATE_NAV_CONFIG_RESPONSE, NAV_RENDERED_FROM_LOCAL_STORAGE, NAV_RENDER_FAILURE } from '../constants/metrics';
import { captureException } from '../utils/sentryAPI';
export function getConfig(configCallback) {
  const portalId = getPortalId();
  const path = `/navconfig/v5/navconfig${portalId ? `?portalId=${portalId}` : ''}`;
  const onError = err => {
    if (err.status !== 401) {
      // Only capturing actionable failures
      Metrics.counter(GET_CONFIG_FAILURE, {
        errorStatus: err.status.toString()
      }).increment();
      captureException(err);
    }
    const navConfigs = JSON.parse(get('hubspot_navconfigs') || '{}');
    if (portalId && navConfigs[portalId] && configCallback) {
      Metrics.counter(NAV_RENDERED_FROM_LOCAL_STORAGE).increment();
      configCallback(navConfigs[portalId]);
    } else {
      Metrics.counter(NAV_RENDER_FAILURE).increment();
      configCallback(null);
    }
  };
  const setGoodRes = res => {
    // We experience the localstorage takes too much space.
    // So we will remove the data when the navconfig return the correct data.
    // https://hubspot.slack.com/archives/C02UXA5SJTV/p1645647586316439
    const navConfigs = {
      [`${portalId}`]: res
    };
    if (res.isAccurate && portalId) {
      set('hubspot_navconfigs', JSON.stringify(navConfigs));
    }
    if (!res.isAccurate) {
      Metrics.counter(INACCURATE_NAV_CONFIG_RESPONSE).increment();
    }
    return configCallback ? configCallback(portalId && navConfigs[portalId] || res) : null;
  };
  return apiClientWithMiddleware().get(path).then(setGoodRes).catch(onError);
}
export function getHublessConfig(configCallback) {
  const path = '/navconfig/v2/navconfig/hubless';
  return apiClientWithMiddleware().get(path).then(configCallback).catch(err => {
    if (err.status === 401) {
      return;
    }
    Metrics.counter(GET_HUBLESS_CONFIG_FAILURE, {
      errorStatus: err.status.toString()
    }).increment();
    captureException(err);
  });
}
export function invalidateNavConfigCache(portalId) {
  const urlSlug = `/navconfig/v5/navconfig/cache?portalId=${portalId}`;
  return apiClientWithMiddleware().delete(urlSlug).catch(error => {
    if (error.status === 401) {
      return;
    }
    captureException(error);
  });
}